import React from 'react'

const index = props => {
  return <div>DMM Banner Page</div>
}

export default index
